<template>
  <div class="IDCardValid">
    <div class="upload">
      <input id="IDCard" name="IDCard" type="file" accept="image/png,image/jpeg" @change="change" v-show="state==null">
      <div class="review" v-if="review">
        <img :src="review">
      </div>
    </div>
    <div class="bt" v-if="state==true">
      <span @click="reset"><Icon type="md-refresh" size="18" color="#5E8FFC" />&nbsp;{{$t('btn.b3')}}</span>
    </div>
    <div class="text" v-if="state==null">
      <span class="warning" v-if="errText">{{errText}}</span>
      <span v-if="!errText">{{$t('msg.m2')}}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errText: "",
      // 预览图片
      review: "",
      uploading:false,
      state:null
    };
  },
  methods: {
    change(e) {
      let file = e.target.files[0];
      // 验证
      if (!file) {
        this.errText = "";
        this.review = "";
        this.$emit("valid", false);
        return;
      }
      if (["image/png", "image/jpeg"].indexOf(file.type) == -1) {
        this.errText = this.$t('msg.m3');
        this.review = "";
        this.$emit("valid", false);
        return;
      }
      // if (file.size > 4 * 1024 * 1024) {
      //   this.errText = "文件大小不能超过4M";
      //   this.review = "";
      //   this.$emit("valid", false);
      //   return;
      // }
      this.errText = "";
      // 预览
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = e => {
        this.review = e.target.result;
      };
      this.file = file;
      this.$emit("valid", true);
    },
    submit() {
      let param = new FormData();
      param.append("facadeFile", this.file);
      this.$axios
      .post("/Member/RZJProfile/EsignUploadFile",param, {
        FormData: true
      })
      .then(res => {
        this.$emit('done',res)
      });
    },
    reset(){
      this.state=null
      this.$emit('reset')
    }
  }
};
</script>

<style lang="less" scoped>
.IDCardValid {
  width: 240px;
  position: relative;
  margin-bottom: 20px;
}
.upload {
  background: url(../assets/security_IDCard.png);
  height: 150px;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  &:before {
    width: 61px;
    height: 48px;
    background: url(../assets/public_upload.png);
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -30.5px;
    margin-top: -24px;
    content: "";
  }
  input {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    opacity: 0;
    z-index: 2;
  }
}
.text {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  margin-top: 5px;
  .warning {
    color: #ed4014;
  }
}
.review {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  img {
    width: 100%;
    height: 100%;
  }
}
.bt{
  color:#5E8FFC;
  display: flex;
  line-height: 20px;
margin-top: 5px;
    justify-content: center;
    >span{
      cursor: pointer;
    }
}
</style>
